import axios from 'axios';

export default function (context, val) {
    let id = val.id;
    let callback = val.callback ? val.callback : () => {
    };
    let noSetData = !!val.noSetData;
    let form = context.rootState.finances.pay.form;
    context.commit('set_item', {id});
    axios({
        url: '/tourclient/payment/invoice?id=' + id,
        method: 'get',
        requestId: 'payment/invoice/id' + id,
    }).then(r => {
        let data = r.data.Item;
        context.commit('set_data', {
            id: id,
            label: data.Name,
            paymentOperation: data.PaymentOperationID,
            contragentType: data.ContragentType,
            contragent: data.ContragentID,
            contragentName: data.ContragentName,
            legal: data.PartnerLegalEntityId ? data.PartnerLegalEntityId : '',
            currency: data.CurrencyId,
            sum: data.Sum,
            data
        });
        context.commit('set_form', {
            id: id,
            Name: data.Name,
            NameLat: data.NameLat,
            PaymentOperationID: data.PaymentOperationID,
            RateArticleId: data.RateArticleId,
            CategoryId: context.rootGetters['dictionary/paymentType/getById'](data.PaymentTypeId).CategoryId,
            PaymentTypeId: data.PaymentTypeId,
            CashId: data.CashId,
            PaymentAccountId: data.PaymentAccountId,
            AccountNumber: data.AccountNumber,
            ContragentType: data.ContragentType,
            ContragentID: data.ContragentID,
            ContragentName: data.ContragentName,
            PartnerLegalEntityId: data.PartnerLegalEntityId ? data.PartnerLegalEntityId : 0,
            PartnerLegalName: data.PartnerLegalName,
            Sum: data.Sum,
            CurrencyId: data.CurrencyId,
            PaymentFor: data.PaymentFor,
            NeedToPayDate: data.NeedToPayDate ? data.NeedToPayDate.Serialized : data.NeedToPayDate,
            AccountDate: data.AccountDate ? data.AccountDate.Serialized : data.AccountDate,
            Comment: data.Comment,
        });
        if(noSetData){
            context.commit('set_data', {
                id: id,
                legals: [
                    {
                        value: data.PartnerLegalEntityId,
                        label: data.PartnerLegalName,
                    }
                ],
                load: false
            });
            callback(context.getters.invoice(id));
            return;
        }
        if (data.PaymentDetails && data.PaymentDetails.length) {
            context.commit('finances/pay/set_form', {
                ContragentType: data.ContragentType,
                ContragentID: data.ContragentID,
                PartnerLegalEntityId: data.PartnerLegalEntityId,
                CurrencyId: data.CurrencyId,
            }, {root: true});
            let load = 0;
            let agreements = [];
            data.PaymentDetails.forEach(i => {
                load++;
                agreements.push(i.Code);
                context.dispatch('finances/pay/agreements/add', {
                    id: i.Code,
                    callback: agreement => {
                        context.dispatch('finances/pay/rates/get',
                            ({
                                date: agreement.date,
                                c1: agreement.currency,
                                c2: form.CurrencyId,
                                callback: (rate) => {
                                    load--;
                                    if (!agreement.course || agreement.course === 1) agreement.ag.course = +rate.course;
                                    if (form.ContragentType === 3) {
                                        if (i.OrderPrices) {
                                            i.OrderPrices.forEach(l => {
                                                agreement.requests.forEach(j => {
                                                    if (l.RequestId === j.value) {
                                                        j.sum += +l.Spread / agreement.ag.course;
                                                    }
                                                });
                                            });
                                        }
                                    } else {
                                        if (agreement.requests[0]) agreement.requests[0].sum += +i.Spread / agreement.ag.course;
                                    }
                                    if (!agreement.comment) agreement.ag.comment = i.Comment;
                                    if (!agreement.startDate && i.Date) agreement.ag.startDate = i.Date.Serialized;
                                    if (!load) {
                                        context.commit('set_data', {id: id, agreements, load: false});
                                        callback(context.getters.invoice(id));
                                    }
                                }
                            }),
                            {root: true});
                    }
                }, {root: true});
            });
        } else {
            context.commit('set_data', {
                id: id,
                legals: [
                    {
                        value: data.PartnerLegalEntityId,
                        label: data.PartnerLegalName,
                    }
                ],
                load: false
            });
            callback(context.getters.invoice(id));
        }
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    });
}